import FormattedMessage from 'I18n/components/FormattedMessage';
import { rethrowError } from 'UIComponents/core/PromiseHandlers';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { useCallback, useEffect, useMemo, useState } from 'react';
import debounce from 'transmute/debounce';
// @ts-expect-error Untyped dependency
import getProperties from 'reporting-data/properties';
import { getCustomWidgetType } from 'reporting-data/report/reportGetters';
// @ts-expect-error Untyped dependency
import ConnectReferenceResolvers from 'reference-resolvers/ConnectReferenceResolvers';
import { EVENTS } from 'reporting-ui-components/lib/events';
import { getUsageTracker } from 'reporting-ui-components/monitoring/usageTracker';
import QuickFilterInput from './QuickFilterInput';
import { getCustomWidgetFilterProperty } from './customWidgetFilterUtils';
import { isValidForQuickFiltering } from './quickFilterEditorUtils';
import { getSubAppFilterProperty } from './subAppFilterUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const label = propertyLabel => /*#__PURE__*/_jsx(FormattedMessage, {
  message: "settingLabels.quickFilter.label",
  options: {
    propertyLabel
  }
});
const QuickFilterEditor = props => {
  const {
    report,
    onChange,
    schema,
    strategy: editorStrategy,
    appUsageTracker,
    resolvers,
    subAppKey
  } = props;
  const [propertiesByName, setPropertiesByName] = useState({});
  const usageTracker = appUsageTracker || getUsageTracker();
  const dataType = editorStrategy.getDataType(report);
  const [inputValue, setInputValue] = useState(editorStrategy.getCurrentValue(report, schema));
  useEffect(() => {
    setInputValue(editorStrategy.getCurrentValue(report, schema));
  }, [editorStrategy, report, schema]);
  useEffect(() => {
    getProperties(dataType).then(dataTypeProperties => {
      const properties = dataTypeProperties.get(dataType);
      setPropertiesByName(properties ? properties.toJS() : {});
    }).catch(rethrowError);
  }, [dataType]);
  const trackAndUpdateReport = useCallback(newValue => {
    usageTracker.track(EVENTS.selectQuickFilter, {
      assetType: 'report',
      actionType: 'edit',
      action: 'filter',
      dataType,
      property: schema.property
    });
    usageTracker.track(EVENTS.changeSrvObjectSpecificFilters, {
      filterType: newValue
    });
    onChange(editorStrategy.updateReport(report, schema, newValue));
  }, [dataType, editorStrategy, onChange, report, schema, usageTracker]);
  const debouncedTrackAndUpdateReport = useMemo(() => debounce(800, trackAndUpdateReport), [trackAndUpdateReport]);
  const handleChange = useCallback(newValue => {
    setInputValue(newValue);
    debouncedTrackAndUpdateReport(newValue);
  }, [debouncedTrackAndUpdateReport]);
  const customWidgetType = getCustomWidgetType(report);
  const filterProperty = useMemo(() => getCustomWidgetFilterProperty(customWidgetType, schema.property) || getSubAppFilterProperty(subAppKey, schema.property) || propertiesByName[schema.property], [propertiesByName, schema.property, customWidgetType, subAppKey]);
  if (!isValidForQuickFiltering(dataType, filterProperty)) {
    if (Object.keys(propertiesByName).length > 0) {
      console.warn(`The '${schema.property}' property is not supported, Quick filters can currently only be
      built on enumeration properties with either options or an external option property with a referenceType.`);
    }
    return null;
  }
  return /*#__PURE__*/_jsx(FormControl, {
    label: label(filterProperty.label),
    children: /*#__PURE__*/_jsx(QuickFilterInput, {
      dataType: dataType,
      filterProperty: filterProperty,
      onChange: handleChange,
      report: report,
      resolvers: resolvers,
      schema: schema,
      value: inputValue
    })
  });
};
export const BaseQuickFilterEditor = ConnectReferenceResolvers(resolvers => ({
  resolvers
}))(QuickFilterEditor);
export const __TESTABLE__ = {
  QuickFilterEditor
};